"use strict";

var _ucfirst = _interopRequireDefault(require("../helpers/ucfirst"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (value, h) {
  if (typeof value !== 'string') return '';

  if (typeof this.$slots["h__".concat(value)] !== 'undefined') {
    return this.$slots["h__".concat(value)];
  }

  var derivedHeading = (0, _ucfirst["default"])(value.split("_").join(" "));
  if (!this.opts.headings.hasOwnProperty(value)) return derivedHeading;

  if (typeof this.opts.headings[value] === 'function') {
    if (h) return this.opts.headings[value].call(this.$parent, h);
    return derivedHeading;
  }

  return this.opts.headings[value];
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-heading.js
// module id = 2598
// module chunks = 0